import { useState } from "react";
import { CloseOutlinedIcon } from "assets/icons";
import useTranslation from "hooks/useTranslation";
import { useDispatch, useSelector } from "react-redux";
import {
  acceptTransferedConversationStart,
  rejectTransferedConversationStart,
} from "redux/chats/chats.actions";
import { useNavigate } from "react-router-dom";

const getAgent = ({ userData }) => userData.agent.data;

const getTransferredConvText = (text, name) => {
  const slittedText = text.split("#");
  slittedText[1] = name;
  return slittedText.join("");
};

function TransferCard({ chat }) {
  const [showCard, setShowCard] = useState(true);
  const { getTranslation } = useTranslation(["CHAT", "COMMON"]);
  const { t } = getTranslation();
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const agent = useSelector(getAgent);

  const handleAcceptConversation = (chat) => {
    let acceptConversationData = {
      status: "3",
      id: chat.conversationId,
      accept: true,
      agent: {
        name: agent.name + agent.lname,
        title: agent.title,
        avatar: agent.avatar,
      },
      userId: chat.userId,
    };
    dispatch(
      acceptTransferedConversationStart(acceptConversationData, navigate)
    );
  };

  const handleRejectConversation = (chat) => {
    let rejectConversationData = {
      status: "4",
      id: chat.conversationId,
      accept: true,
      userId: chat.userId,
    };
    dispatch(rejectTransferedConversationStart(rejectConversationData));
  };

  const handleCloseBtnClick = () => {
    setShowCard(false);
  };

  if (showCard) {
    return (
      <div className="transfered_conversation_container">
        <div className="transfered_conversation_container__close_btn">
          <img
            onClick={handleCloseBtnClick}
            src={CloseOutlinedIcon}
            alt="close"
          />
        </div>
        <div className="flex flex-ai-c transfered_conversation_operator_info">
          <img
            alt="transfer_chat"
            src={chat.avatar}
            className="transfer_chat_operator_avatar"
          />
          <p>{getTransferredConvText(t("TRANSFERED_CONV_TEXT"), chat.name)}</p>
        </div>
        <div className="flex flex-ai-c flex-jc-e transfered_conversation_actions">
          <button
            onClick={() => handleRejectConversation(chat)}
            className="btn btn-tertiary"
            id="closeModal"
          >
            {t("REJECT")}
          </button>
          <button
            onClick={() => handleAcceptConversation(chat)}
            className="btn btn-primary"
          >
            {t("ACCEPT")}
          </button>
        </div>
      </div>
    );
  }

  return null;
}

export default TransferCard;
